module.exports = __webpack_public_path__ + "static/media/s_v5_t5.03fa4846.mp3";